import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import { SideFlag } from '../SideFlag';
import styles from './DailyRewards.module.scss';
import { useTranslation } from 'react-i18next';

import TowerTokenIcon from '../../assets/imgs/tower-token 1.png';
import { RewardCalendar } from '../RewardCalendar';
import { RewardProgressView } from '../RewardProgressView/RewardProgressView';
import { countdownTimer } from '../../services/TimerService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GeneralModal } from '../GeneralModal';
import commonMapIcon from "../../assets/imgs/map_common.png";
import rareMapIcon from "../../assets/imgs/map_rare.png";
import epicMapIcon from "../../assets/imgs/map_epic.png";
import legendaryMapIcon from "../../assets/imgs/map_legendary.png";
import commonMapIconT from "../../assets/imgs/map_common_transparent.png";
import rareMapIconT from '../../assets/imgs/map_rare_transparent.png';
import epicMapIconT from '../../assets/imgs/map_epic_transparent.png';
import legendaryMapIconT from '../../assets/imgs/map_legendary_transparent.png';
// import ChestOpeningImage from '../../assets/imgs/chest-opening_banner.png';
import BoxPrize from '../../assets/imgs/box-prize.png';
import BoxPrizeBrown from '../../assets/imgs/box-prize-brown.png';
import ExtraDayBadge from '../../assets/imgs/treasure_chest_badge.png';
import ExtraDayBadgeBrown from '../../assets/imgs/treasure_chest_badge_brown.png';
// import NeoPetsDragon from '../../assets/imgs/neo_pets_dragon.png';
// import NeoPetsClueTwo from '../../assets/imgs/neo_pets_clue_2.png';
// import { Modal } from 'react-bootstrap';
// import closeIcon from '../../assets/icons/btn-close-X.svg';
// import ThreeStars from '../../assets/imgs/three_stars.png';
import { NoBattleCardsOwnedNotice } from '../ViewTower/NoBattleCardsOwnedNotice';

const DailyRewards = (props) => {
    const { cdhUserId, starChestInfo, uniquePlayerId, walletInfo, totalEventEarnings, setTotalEventEarnings, claimed, setClaimed, getStarChestData, userBattleCardCount, userTicketCount } = props;
    const [t] = useTranslation();
    const [countdownTime, setCountdownTime] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const [daysBonus, setDaysBonus] = useState(0);
    const [nextDaysBonus, setNextDaysBonus] = useState(0);
    const [currentIteration, setCurrentIteration] = useState(0);
    const [remainingDays, setRemainingDays] = useState(0);
    const [endOfMonthDate, setEndOfMonthDate] = useState(0);
    const [loading, setLoading] = useState(true);
    const [claimedAllThisMonth, setClaimedAllThisMonth] = useState(false);
    const [earningObtainNotice, setEarningObtainNotice] = useState(false);

    // const [showNeoPetsModal, setShowNeoPetsModal] = useState(false);

    const sevenDayBonus = useMemo(() => {
        let bonusDays = {
            7: {
                value: 7,
                image: commonMapIcon,
                imageT: commonMapIconT,
                name: t('COMMON') + t('MAP'),
                type: t('COMMON'),
                stylingName: 'Common'
            },
            14: {
                value: 14,
                image: rareMapIcon,
                imageT: rareMapIconT,
                name: t('RARE') + t('MAP'),
                type: t('RARE'),
                stylingName: 'Rare'
            },
            21: {
                value: 21,
                image: epicMapIcon,
                imageT: epicMapIconT,
                name: t('EPIC') + t('MAP'),
                type: t('EPIC'),
                stylingName: 'Epic'
            },
            28: {
                value: 28,
                image: legendaryMapIcon,
                imageT: legendaryMapIconT,
                name: t('LEGENDARY') + t('MAP'),
                type: t('LEGENDARY'),
                stylingName: 'Legendary'
            }
        }

        if (endOfMonthDate && endOfMonthDate !== 28) {
            let i=29;
            while (i <= endOfMonthDate) {
                if (i === endOfMonthDate) {
                    bonusDays[endOfMonthDate] = {
                        value: 0,
                        name: t('Attendance Badge'),
                        image: ExtraDayBadge,
                        imageT: ExtraDayBadgeBrown,
                        type: <div>{t('Attendance')} + <img
                                src={currentIteration + remainingDays < endOfMonthDate ? BoxPrizeBrown : BoxPrize}
                                alt="attendance-badge"
                                className={styles.rewards_image}
                                style={{ opacity: currentIteration + remainingDays < endOfMonthDate ? "0.5" : '' }}
                            /></div>,
                        content: <div className={styles.extra_rewards}>
                                <div className={styles.reward_item}>
                                    <img src={ExtraDayBadge} alt="attendance-badge" className={styles.rewards_image} />
                                    <span>{t('Attendance')}</span>
                                </div>
                                <div className={styles.reward_item}>
                                    <img src={BoxPrize} alt="mint-pass" className={styles.rewards_image} />
                                    <span>{t('Crazo Mint Pass')}</span>
                                </div>
                            </div>,
                        stylingName: 'AttendanceDayBadge',
                        additionalReward: t('Crazo Mint Pass'),
                    }
                } else {
                    bonusDays[i] = {
                        value: 0,
                        name: t('Crazo Mint Pass'),
                        type: t('Crazo Mint Pass'),
                        content: <div className={styles.extra_rewards}>
                                <div className={styles.reward_item}>
                                    <img src={BoxPrize} alt="mint-pass" className={styles.rewards_image} />
                                    <span>{t('Crazo Mint Pass')}</span>
                                </div>
                            </div>,
                        stylingName: 'CrazoMintPass'
                    }    
                }
                i += 1;
            }
        }
        return bonusDays;
    }, [endOfMonthDate]);    

    const checkBonusClaimedDays = (calendarInfo) => {
        let totalBonusClaimedDays = 0;
        calendarInfo.forEach((eachDay) => {
            if (eachDay.userSignedTransaction === true) {
                totalBonusClaimedDays++;
            }
        });
        return totalBonusClaimedDays;
    }

    useEffect(() => {
        if (starChestInfo && uniquePlayerId) {
            if (!totalEventEarnings) {
                setTotalEventEarnings(starChestInfo?.totalTowerTokensEarned);
            }
            let claimedDays = checkBonusClaimedDays(starChestInfo?.calender_info);
            setCurrentIteration(claimedDays + 1);
            
            let currentDate = new moment.utc(starChestInfo?.currentDate);
            const endOfMonth = moment.utc(starChestInfo?.currentDate).endOf('month');

            setEndOfMonthDate(parseInt(endOfMonth.format("DD")));
            setRemainingDays(endOfMonth.diff(currentDate, 'days'));
            countdownTimer(endOfMonth, setCountdownTime, currentDate);

            let lengthOfStarChestInfo = starChestInfo?.calender_info?.length;
            let mostRecentClaim = starChestInfo?.calender_info[lengthOfStarChestInfo - 1];
            let mostRecentClaimDate = mostRecentClaim?.date ? new moment.utc(mostRecentClaim.date, 'YYYY-MM-DD') : new moment().utc();

            if (currentDate.format('YYYY-MM-DD') === mostRecentClaimDate.format('YYYY-MM-DD') && mostRecentClaim?.userSignedTransaction) {
                setCurrentIteration(claimedDays);
                setClaimed(true)
            }
            setLoading(false);
        }
    }, [starChestInfo, uniquePlayerId])

    // useEffect(() => {
    //     if (remainingDays >= 0 && (28 - currentIteration) < 0) {
    //         setClaimedAllThisMonth(true);
    //     }
    // }, [remainingDays, currentIteration, claimed])

    return (
        <div className={styles.daily_rewards_contianer}>
            <div className={styles.side_flag_container}>
                {/* <img src={NeoPetsClueTwo} alt="neo-pets-clue" className={styles.neo_pet_clue_img} onClick={() => setShowNeoPetsModal(true)} /> */}
                <SideFlag
                    claimed={claimed}
                    daysBonus={daysBonus}
                    nextDaysBonus={nextDaysBonus}
                    countdownTime={countdownTime}
                    claimedAllThisMonth={claimedAllThisMonth}
                    currentIteration={currentIteration}
                    endOfMonthDate={endOfMonthDate}
                />
            </div>
            <div className={styles.daily_rewards_section_container}>
                <div className={styles.section_title}>
                    <div className={styles.title_text_daily}>
                        <span className={styles.title}>{t('DAILY_REWARDS')}</span>
                        {/* <span className={styles.title_countdown}>{t('TIME_REMAINING')} {countdownTime?.days}{t('DAY_KEY')} {countdownTime?.hours}{t('HOUR_KEY')}</span> */}
                    </div>
                </div>
                <div className={styles.rewards_container}>
                <NoBattleCardsOwnedNotice battleCardsCount={userBattleCardCount} userTicketCount={userTicketCount} />

                    <div className={styles.container_section_headers}>
                        <div className={styles.total_event_earning}>
                            <img src={TowerTokenIcon} alt="tower-token" />
                            <div>
                                <div className={styles.earning_title}>{t('DAILY_REWARDS_THIS_MONTH')}
                                    <FontAwesomeIcon icon="exclamation-circle" className={styles.info_icon} onClick={() => setEarningObtainNotice(true)} />
                                </div>
                                <div className={styles.token_count}>{totalEventEarnings}</div>
                            </div>
                        </div>

                        <div className={styles.star_reward_send_notice}>
                            {/* <FontAwesomeIcon icon="exclamation-circle" style={{ margin: "2px 2px 0 0" }} /> */}
                            <div>{t('DAILY_STAR_REWARD_SEND_NOTICE')}</div>
                        </div>
                    </div>
                    
                    <div className={styles.container_section_body}>
                        {loading && <div className={styles.loading}>{t('LOADING_SCREEN')}</div>}
                        {/* {claimedAllThisMonth &&
                            <div className={styles.all_claimed}>
                                <img src={ChestOpeningImage} alt="chest-opening-banner" className={styles.chest_opening_img} />
                                <span className={styles.claimed_text}>{t('CLAIMED_ALL_REWARDS_THIS_MONTH')}</span>
                                <span>{t('COME_BACK_AGAIN')}</span>
                                <span>{claimedAllThisMonth && <>{countdownTime?.days}{t('DAY_KEY')}</>} {countdownTime?.hours}{t('HOUR_KEY')} {countdownTime?.minutes}{t('MINUTE_KEY')}</span>
                            </div>
                        } */}

                        <RewardCalendar
                            currentIteration={currentIteration}
                            remainingDays={remainingDays}
                            endOfMonthDate={endOfMonthDate}
                            claimed={claimed}
                            setClaimed={setClaimed}
                            daysBonus={daysBonus}
                            setDaysBonus={setDaysBonus}
                            nextDaysBonus={nextDaysBonus}
                            setNextDaysBonus={setNextDaysBonus}
                            totalEventEarnings={totalEventEarnings}
                            setTotalEventEarnings={setTotalEventEarnings}
                            cdhUserId={cdhUserId}
                            uniquePlayerId={uniquePlayerId}
                            setLoading={setLoading}
                            walletInfo={walletInfo}
                            countdownTime={countdownTime}
                            starChestInfo={starChestInfo}
                            sevenDayBonus={sevenDayBonus}
                            getStarChestData={getStarChestData}
                        />
                    </div>
                </div>
                <div className={styles.rewards_progress_bar}>
                    {/* <img src={NeoPetsClueTwo} alt="neo-pets-clue" className={styles.neo_pet_clue_img} onClick={() => setShowNeoPetsModal(true)} /> */}
                    <RewardProgressView
                        currentIteration={currentIteration}
                        remainingDays={remainingDays}
                        endOfMonthDate={endOfMonthDate}
                        claimed={claimed}
                        sevenDayBonus={sevenDayBonus}
                        claimedAllThisMonth={claimedAllThisMonth}
                    />
                </div>
            </div>

            <GeneralModal content={{
                show: earningObtainNotice,
                showSetter: setEarningObtainNotice,
                title: t('Pending to be transferred'),
                description: t('DAILY_STAR_REWARD_SEND_NOTICE'),
                buttonText: t('OK'),
                buttonCallback: () => setEarningObtainNotice(false)
            }} />

            {/* <Modal show={showNeoPetsModal} dialogClassName={styles.neo_pet_modal} centered contentClassName={styles.neo_pet_modal_content} onHide={() => setShowNeoPetsModal(false)}>
                <div className={styles.close_btn} onClick={() => setShowNeoPetsModal(false)}>
                    <img src={closeIcon} alt="close" />
                </div>
                <Modal.Body bsPrefix={styles.neo_pet_modal_body}>
                    <div className={styles.three_stars_img}>
                        <img src={ThreeStars} alt="three-stars" />
                    </div>
                    <p className={styles.modal_descriptions}>
                        First Clue link: https://twitter.com/neopetsmeta/status/1559208468405489664?s=21&t=E14l_urCeJ72HxCIuhnTbw
                        
                        You found <a href="https://twitter.com/neopetsmeta/status/1561716114568220673?s=21&t=5NXYZXbjYknxGZB0e9BwHw" target="_blank" rel="noopener noreferrer">the Clue</a>!
                    </p>
                    <p className={styles.modal_descriptions}>
                        Find the man in <a href="https://neopetsmeta.io/" target="_blank" rel="noopener noreferrer">neopetsmeta.io</a> that builds the world of Neopia, hidden behind Lupe ears.
                        
                        A vessel of flavour, that in the scorching sun fails its duties.
                    </p>
                </Modal.Body>
            </Modal> */}
        </div>
    )
};

export { DailyRewards };